import { createRouter, createWebHistory } from 'vue-router';
import Login from './views/Login.vue';
import ResetPassword from './views/ResetPassword.vue';
import { fetchUserInfo } from './services/user';
import Users from './views/Users.vue';
import Services from './views/Services.vue';
import Clients from './views/Clients.vue';
import Client from './views/Client.vue';
import Suppliers from './views/Suppliers.vue';
import Register from './views/Register.vue';
import Groups from './views/Groups.vue';
import Projects from './views/Projects.vue';
import HostingOld from './views/HostingOld.vue';
import Hosting from './views/Hosting.vue'
import Holidays from './views/Holidays.vue';
import DaysOff from './views/DaysOff.vue';
import DaysOffRequests from './views/DaysOffRequests.vue';
import OtherRequests from './views/OtherRequests.vue';
import MissingHours from './views/MissingHours.vue';
import Project from './views/Project.vue';
import Host from './views/Host.vue';
import Task from './views/Task.vue';
import SubTask from './views/SubTask.vue';
import HoursRequests from './views/HoursRequests.vue';
import ToDo from './views/ToDo.vue';
import FollowUp from './views/FollowUp.vue';
import Notifications from './views/Notifications.vue';
import Hours from './views/Hours.vue';
import DaysOffReports from './views/DaysOffReports.vue';
import ContactsClients from './views/ContactsClients.vue';
import Contacts from './views/Contacts.vue';
import ContactsSuppliers from './views/ContactsSuppliers.vue';
import OrphanedContacts from './views/OrphanedContacts.vue';
import ChangeProfile from './views/ChangeProfile.vue';
import NotificationSettings from './views/NotificationSettings.vue';
import Reports from './views/Reports.vue';
import EditDashboard from './views/EditDashboard.vue';
import BoxIntegration from './views/BoxIntegration.vue';
import HistoryChanges from './views/HistoryChanges.vue';
import MyPermissions from './views/MyPermissions.vue';
import Supplier from './views/Supplier.vue';
import Contacts2 from './views/Contacts2.vue';
import Contact from './views/Contact.vue';
import Lists from './views/Lists.vue';
import EditList from './views/EditList.vue';
import List from './views/List.vue';
import ProjectReport from './views/ProjectReport.vue';
import TaskReport from './views/TaskReport.vue';
import CrmMenu from './views/CrmMenu.vue';
import HrMenu from './views/HrMenu.vue';
import ProjectManagementMenu from './views/ProjectManagementMenu.vue';
import ReportingAnalyticsMenu from './views/ReportingAnalyticsMenu.vue';
import MarketingHubMenu from './views/MarketingHubMenu.vue';
import MedMenu from './views/MedMenu.vue';
import FileManagementMenu from './views/FileManagementMenu.vue';
import DashboardMenu from './views/DashboardMenu.vue';
import NewEmployeeForm from './views/NewEmployeeForm.vue';
import EmployeesDaysOff from './views/EmployeesDaysOff.vue';
import Employees from './views/Employees.vue';
import EmployeeProfile from './views/EmployeeProfile.vue';
import UnderRecruitmentProfile from './views/UnderRecruitmentProfile.vue';
import UnderRecruitment from './views/UnderRecruitment.vue';
import AccountantDashboard from './views/AccountantDashboard.vue';
import store from '@/store';


const routes = [
  
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { layout: 'LoginLayout' }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { layout: 'ResetPasswordLayout' }
  },
  {
    path: '/notification-settings',
    name: 'Notification Settings',
    component: NotificationSettings,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { layout: 'MainLayout' }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      layout: 'NoLayout' // No layout for Register component
    },
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: {
      layout: 'MainLayout'
    },
  },
  {
    path: '/lists',
    name: 'Lists',
    component: Lists,
    meta: {
      layout: 'MainLayout'
    },
  },
  {
    path: '/edit-list',
    name: 'EditList',
    component: EditList,
    meta: {
      layout: 'MainLayout'
    },
  },
  {
    path: '/list-profile',
    name: 'List',
    component: List,
    meta: {
      layout: 'MainLayout'
    },
  },
  {
    path: '/service-categories',
    name: 'Groups',
    component: Groups,
    meta: {
      layout: 'MainLayout'
    },
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients,
    meta: {
      layout: 'MainLayout'
    },
  },  
  {
    path: '/client',
    name: 'Client',
    component: Client,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/suppliers',
    name: 'Suppliers',
    component: Suppliers,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/contacts2',
    name: 'Contacts2',
    component: Contacts2,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/contacts-clients',
    name: 'ContactsClients',
    component: ContactsClients,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/contacts-suppliers',
    name: 'ContactsSuppliers',
    component: ContactsSuppliers,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/orphaned-contacts',
    name: 'OrphanedContacts',
    component: OrphanedContacts,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/hosting',
    name: 'Hosting',
    component: Hosting,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/project',
    name: 'Project',
    component: Project,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/host',
    name: 'Host',
    component: Host,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/holidays',
    name: 'Holidays',
    component: Holidays,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/days-off',
    name: 'DaysOff',
    component: DaysOff,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/days-off-requests',
    name: 'DaysOffRequests',
    component: DaysOffRequests,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/other-requests',
    name: 'OtherRequests',
    component: OtherRequests,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/missing-hours',
    name: 'MissingHours',
    component: MissingHours,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/task',
    name: 'Task',
    component: Task,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/subtask',
    name: 'SubTask',
    component: SubTask,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/hours-requests',
    name: 'HoursRequests',
    component: HoursRequests,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/to-do',
    name: 'ToDo',
    component: ToDo,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/follow-up',
    name: 'FollowUp',
    component: FollowUp,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/hours',
    name: 'Hours',
    component: Hours,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/days-off-reports',
    name: 'Days Off Reports',
    component: DaysOffReports,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/task',
    name: 'Task',
    component: Task,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/change-profile',
    name: 'ChangeProfile',
    component: ChangeProfile,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/project-report',
    name: 'ProjectReport',
    component: ProjectReport,
    meta: {
      layout: 'MainLayout'
    }
  },  
  {
    path: '/task-report',
    name: 'TaskReport',
    component: TaskReport,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/edit-dashboard',
    name: 'Edit Dashboard',
    component: EditDashboard,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/box-integration',
    name: 'Box Integration',
    component: BoxIntegration,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/history-changes',
    name: 'History Changes',
    component: HistoryChanges,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/contact/',
    name: 'Contact',
    component: Contact,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/supplier/',
    name: 'Supplier',
    component: Supplier,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/my-permissions',
    name: 'My Permissions',
    component: MyPermissions,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/crm-menu',
    name: 'CRM Menu',
    component: CrmMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/pm-menu',
    name: 'Project Management Menu',
    component: ProjectManagementMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/reporting-analytics-menu',
    name: 'Reporting Analytics Menu',
    component: ReportingAnalyticsMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/file-management-menu',
    name: 'File Management Menu',
    component: FileManagementMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/hr-menu',
    name: 'HR Menu',
    component: HrMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/marketing-hub-menu',
    name: 'Marketing Hub Menu',
    component: MarketingHubMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/med-menu',
    name: 'MED Menu',
    component: MedMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard Menu',
    component: DashboardMenu,
    meta: {
      layout: 'MainLayout'
    }
  },
  {
    path: '/new-employee-form',
    name: 'NewEmployeeForm',
    component: NewEmployeeForm,
    meta: {
      layout: 'NoLayout' 
    },
  },
   {
    path: '/employees',
    name: 'Employees',
    component: Employees,
    meta: {
      layout: 'MainLayout' 
    },
  }, 
  {
    path: '/employees-days-off',
    name: 'EmployeesDaysOff',
    component: EmployeesDaysOff,
    meta: {
      layout: 'MainLayout' 
    },
  },
  ,
  {
    path: '/under-recruitment',
    name: 'UnderRecruitment',
    component: UnderRecruitment,
    meta: {
      layout: 'MainLayout' 
    },
  },
  {
    path: '/employee-profile',
    name: 'EmployeeProfile',
    component: EmployeeProfile,
    meta: {
      layout: 'MainLayout' 
    },
  },
  {
    path: '/under-recruitment-profile',
    name: 'UnderRecruitmentProfile',
    component: UnderRecruitmentProfile,
    meta: {
      layout: 'MainLayout' 
    },
  },
  
  {
    path: '/accountant-dashboard',
    name: 'AccountantDashboard',
    component: AccountantDashboard,
    meta: {
      layout: 'MainLayout' 
    },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// ✅ Vue Router 4 style async navigation guard
router.beforeEach(async (to, from) => {
  // Meta tags (optional, not causing issues)
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  if (nearestWithMeta) {
    nearestWithMeta.meta.metaTags.forEach(tag => {
      const element = document.createElement('meta');
      Object.keys(tag).forEach(key => element.setAttribute(key, tag[key]));
      document.head.appendChild(element);
    });
  }

  const publicPages = ['Login', 'ResetPassword', 'NewEmployeeForm'];
  const authRequired = !publicPages.includes(to.name);
  const token = localStorage.getItem('api_token');

    // Redirect '/' to '/dashboard' if user is logged in
  if (to.path === '/' && token) {
    return { path: '/dashboard' };
  }

  if (authRequired) {
    try {
      const userInfo = await fetchUserInfo();
      if (!userInfo || userInfo.data.info == null) throw new Error('Invalid/expired token');
      return true;
    } catch (error) {
      localStorage.removeItem('api_token');
      return { name: 'Login' };
    }
  } else {

      return true;
    }
});

router.beforeEach((to, from, next) => {
  const userPackets = store.getters.getUserPackets;
  const isAccountant = store.getters.getIsAccountant;

  const hasHR = userPackets.includes('HR') && isAccountant !== 1;
  const hasProjectManagement = userPackets.includes('PROJECT MANAGEMENT') && isAccountant !== 1;
 const hasCRM = userPackets.includes('CRM') && isAccountant !== 1;
  const hasMED = userPackets.includes('MED') && isAccountant !== 1; 
  const hasMarketingHub = userPackets.includes('MARKETING HUB') && isAccountant !== 1;
  const hasFileManagement = userPackets.includes('FILE MANAGEMENT') && isAccountant !== 1;
  

    const restrictedPathsAccountant = [
    '/accountant-dashboard',
     '/under-recruitment',
     '/under-recruitment-profile',
     '/employees-days-off',
     '/employee-profile'
  ];

   const isRestrictedAccountantRoute = restrictedPathsAccountant.some(path => to.path.includes(path));
   

  if (isRestrictedAccountantRoute && isAccountant!== 1 ) {
if (hasProjectManagement) {
      return next('/projects');
    } else {
if(isAccountant !== 1){
        return next('/users');
      }else{
         return next('/accountant-dashboard');
      }    }
  }

  if(!isRestrictedAccountantRoute && isAccountant === 1 && to.path !== '/change-profile' && to.path !== '/notifications'){
             return next('/accountant-dashboard');

  }


  const restrictedPathsHR = [
    '/days-off',
    '/days-off-requests',
    '/other-requests',
    '/days-off-reports',
    '/holidays',
    '/hr-menu'
  ];

  const isRestrictedHRRoute = restrictedPathsHR.some(path => to.path.includes(path));

  if (isRestrictedHRRoute && !hasHR) {
    if (hasProjectManagement) {
      return next('/projects');
    } else {
      if(isAccountant !== 1){
        return next('/users');
      }else{
         return next('/accountant-dashboard');
      }
    }
  }



  const restrictedPathsProjectManagement = [
    '/projects',
    '/project',
    '/task',
    '/subtask',
    '/hours',
    '/reports', '/follow-up', '/to-do', 'missing-hours',
     '/edit-dashboard',
    '/notification-settings', '/hosting',
    '/pm-menu', '/reporting-analytics-menu'
  ];

  const isRestrictedProjectManagementRoute = restrictedPathsProjectManagement.some(path => to.path.includes(path));

  if (isRestrictedProjectManagementRoute && !hasProjectManagement) {
if(isAccountant !== 1){
        return next('/users');
      }else{
         return next('/accountant-dashboard');
      }  }

  
  const restrictedPathsMarketingHub = [
    '/lists',
    '/new-list','/marketing-hub-menu'
  
  ];

  const isRestrictedMarketingHubRoute = restrictedPathsMarketingHub.some(path => to.path.includes(path));

  if (isRestrictedMarketingHubRoute && !hasMarketingHub) {
if (hasProjectManagement) {
      return next('/projects');
    } else {
if(isAccountant !== 1){
        return next('/users');
      }else{
         return next('/accountant-dashboard');
      }    }  }

  const restrictedPathsFileManagement = [];

  const isRestrictedFileManagementRoute = restrictedPathsFileManagement.some(path => to.path.includes(path));

  if (isRestrictedFileManagementRoute && !hasFileManagement) {
if (hasProjectManagement) {
      return next('/projects');
    } else {
if(isAccountant !== 1){
        return next('/users');
      }else{
         return next('/accountant-dashboard');
      }    }  }

  next();
});



export default router;
